<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { isLogin } from 'service/login'
import { CODE_OK } from './utils/const'
export default {
  data() {
    return {}
  },
  created() {
    // isLogin().then(res => {
    //   if (res.code !== CODE_OK) {
    //     // this.$router.push({ name: 'login' })
    //   }
    // })
  }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
